import React, { FC, HTMLAttributes } from 'react';
import moment from 'moment';

export interface TableInfoProps extends HTMLAttributes<HTMLDivElement> {
  date: Date | moment.Moment | string;
  data: any[];
  label: string;
}

export const TableInfo: FC<TableInfoProps> = ({
  date,
  data,
  label,
}: TableInfoProps) => {
  /* Checking for missing required props */
  // if (!date)
  //   throw new Error(
  //     `You need to pass a prop called "date" of type Date or Moment or String to the TableInfo component. To learn more about the list of required props for the
  //     TableInfo component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/tables-table--table-info`
  //   );

  // if (!data)
  //   throw new Error(
  //     `You need to pass a prop called "data" of type Array to the TableInfo component. To learn more about the list of required props for the
  //     TableInfo component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/tables-table--table-info`
  //   );

  // if (!label)
  //   throw new Error(
  //     `You need to pass a prop called "label" of type string to the TableInfo component. To learn more about the list of required props for the
  //     TableInfo component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/tables-table--table-info`
  //   );
  /* Checking for missing required props */
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const formatDate = () => {
    if (moment.isMoment(date)) {
      return `${months[date.month()]} ${date.date()}`;
    } else if (typeof date === 'string') {
      return date;
    } else {
      return `${months[date.getMonth()]} ${date.getDate()}`;
    }
  };

  return (
    <div className="w-full bg-thryv-white-200 border-b border-thryv-gray-light-400">
      <div className="px-[30px] py-[13px] flex justify-between items-center">
        <h6 className="text-thryv-steel font-normal font-montserrat text-[12px]">
          {formatDate()}
        </h6>
        <h6 className="text-thryv-steel font-normal font-montserrat text-[12px]">
          {data.length} <span className="capitalize">{label}</span>
        </h6>
      </div>
    </div>
  );
};
